import { render, staticRenderFns } from "./moveSafeGroup.vue?vue&type=template&id=280c9720&scoped=true&"
import script from "./moveSafeGroup.vue?vue&type=script&lang=js&"
export * from "./moveSafeGroup.vue?vue&type=script&lang=js&"
import style0 from "./moveSafeGroup.vue?vue&type=style&index=0&id=280c9720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c9720",
  null
  
)

component.options.__file = "moveSafeGroup.vue"
export default component.exports